const Social = () => {
    return (
        <div className="social">
            <h2>Socials</h2>

            <a href="" className="button">ginli2022@gmail.com</a>
            <a href="https://twitter.com/ginbitcoin" className="button">Twitter</a>
            <a href="https://www.linkedin.com/in/jing-li-0981348b/" className="button">LinkedIn</a>
            <a href="https://github.com/fakemonkgin" className="button">GitHub</a>
            <a href="https://open.spotify.com/album/7BVQECIwShAPVdbTxxHpMM" className="button">Spotify</a>
        </div>
    );
}

export default Social;